
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.886 6.06H7.713v1.613h7.173V6.06z","fill":"#98A3B3"}}),_c('path',{attrs:{"d":"M18.463.184h-4.74l1.144 1.63 3.47 1.057a1.473 1.473 0 011.039 1.434V9.5c0 .645-.413 1.236-1.038 1.434l-3.453 1.058-1.163 1.63h4.741a3.58 3.58 0 003.577-3.584v-6.27c.018-1.972-1.592-3.584-3.577-3.584zm-14.346 0h4.74l-1.144 1.63L4.259 2.87a1.472 1.472 0 00-1.036 1.434V9.5a1.5 1.5 0 001.038 1.434l3.452 1.058 1.145 1.63H4.117A3.59 3.59 0 01.54 10.037v-6.27A3.59 3.59 0 014.117.184z","fill":"#98A3B3"}})])
          )
        }
      }
    